import React from 'react';
import { Query } from 'react-apollo';
import { getBlsOrderById } from '../schema/bls-schema.graphql';
// @material-ui/core components
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
// @material-ui/icons
// core components
import GridItem from 'components/Grid/GridItem.jsx';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardIcon from 'components/Card/CardIcon.jsx';

import Train from '@material-ui/icons/Train';
import Receipt from '@material-ui/icons/Receipt';
import Money from '@material-ui/icons/Money';
import BlsOrderDetailsForm from './OrderDetailsForm';
import Spinner from '../../../components/Spinner/Spinner';
import BlsTicketTable from './BlsTicketTable';
import Payment from '../../payment/Payment';
import GridContainer from '../../../components/Grid/GridContainer';

const BlsOrder = props => {
  const { onUserClick, order } = props;
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12} lg={6}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="info">
              <Train />
            </CardIcon>

            <div
              style={{
                marginTop: 60,
                display: 'flex',
                width: '100%',
                alignItems: 'flex-start',
              }}
            >
              <div style={{ flex: 1 }}>
                <Typography variant="headline" color="textSecondary">
                  Bestellungs &Uuml;bersicht
                </Typography>
              </div>
              {order ? (
                <Chip
                  label={order.user.email}
                  style={{ backgroundColor: '#00acc1', color: 'white' }}
                  clickable
                  onClick={() => onUserClick(order.user.id)}
                />
              ) : null}
            </div>
          </CardHeader>
          <CardBody>
            {order ? (
              <BlsOrderDetailsForm order={order} />
            ) : (
              <Spinner loading />
            )}
          </CardBody>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={12} md={12} lg={6}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="info">
              <Money />
            </CardIcon>

            <div
              style={{
                marginTop: 60,
                display: 'flex',
                width: '100%',
                alignItems: 'flex-start',
              }}
            >
              <div style={{ flex: 1 }}>
                <Typography variant="headline" color="textSecondary">
                  Bezahlung
                </Typography>
              </div>
            </div>
          </CardHeader>
          <CardBody>
            {order ? <Payment payment={order.payment} /> : <Spinner loading />}
          </CardBody>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={12} md={12} lg={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="info">
              <Receipt />
            </CardIcon>
          </CardHeader>
          <CardBody>
            <Typography variant="headline" color="textSecondary">
              Tickets
            </Typography>
            {order ? (
              <BlsTicketTable tickets={order.tickets} />
            ) : (
              <Spinner loading />
            )}
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default ({ history, match, ...props }) => (
  <Query query={getBlsOrderById} variables={{ id: match.params.id }}>
    {({ data }) => (
      <BlsOrder
        order={data.order}
        onUserClick={id => history.push(`/users/${id}`)}
        {...props}
      />
    )}
  </Query>
);



// WEBPACK FOOTER //
// ./src/views/bls/components/BlsOrder.jsx